import { render, staticRenderFns } from "./RecordEdit.vue?vue&type=template&id=ff3b8fd2&"
import script from "./RecordEdit.vue?vue&type=script&lang=js&"
export * from "./RecordEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports